<template>
    <div class="w-100 site-panel v-flex" v-if="site">
        <v-row class="no-frame">
            <v-col class="ma-0 pa-0 mr-1 col-2">
                <v-row class="no-frame">
                    <c-inc-maintenance-index
                        style             = "margin-top: 3px"
                        :maintenance-list = "maintenances"
                        @selected         = "onSelected"
                    />
                </v-row>
            </v-col>
            <v-col class="pa-0 col-7">
                <v-row class="no-frame h-100">
                    <c-column-header
                        :label = "documentName"
                        class  = "primary w-100 mt-2"
                    >
                        <template v-slot:filter>
                            <div v-if="documentList">
                                <c-dms-menu-details
                                    :documents = "documentList"
                                    color        = "white--text"
                                    :enable-menu = "false"
                                    :enable-drag = "false"
                                    @selected    = "onDocument"
                                />
                            </div>
                        </template>
                    </c-column-header>
                    <div
                        class="w-100 lm-border pa-2 mt-1"
                        style="height: calc(100% - 45px)"
                    >
                        <c-dms-viewer
                            v-if      ="document"
                            class     = " w-100 h-100"
                            :document = "document.id"
                        />

                    </div>
                </v-row>
            </v-col>
            <v-col class="pa-0 pl-2">
                <v-row class="no-frame" style="height: 850px;" >
                    <c-column-header
                        label = "Wartungsnachweis"
                        class = "primary w-100 mt-2"
                    />
                    <div class="mb-3 w-100 h-100" style="margin-top: 6px">
                        <div v-if="selected" class="lm-border pa-3 w-100">
                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <f-read-only-field
                                        label  = "Servicetechniker"
                                        :value = "selected.technician"
                                    />
                                </v-col>

                            </v-row>

                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <f-read-only-field
                                        :label = "$t('inc.maintenance.exedate')"
                                        :value = "format(selected.executiondate)"
                                    />
                                </v-col>

                                <v-col class="no-frame pl-2">
                                    <f-read-only-field
                                        label  = "Auftragsnummer"
                                        :value = "selected.orderNo"
                                    />
                                </v-col>
                            </v-row>

                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <f-read-only-field
                                        label  = "Vertragsnummer"
                                        :value = "selected.contractNo"
                                    />
                                </v-col>

                                <v-col class="no-frame pl-2">
                                </v-col>
                            </v-row>
                        </div>

                        <v-row class="no-frame mt-4" v-if="selected">
                            <v-col class="no-frame">
                                <div class="readonly-label primary--text">
                                    Beschreibung
                                </div>
                                <div class="mnt-description lm-border" v-html="html (selected.description)">
                                </div>
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-4" v-if="selected">
                            <v-col class="no-frame">
                                <div class="readonly-label primary--text">
                                    Ergebnis
                                </div>
                                <div class="mnt-description lm-border" v-html="html (selected.result)">
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                   from "@/modules/core/service/Core";
import Inc                    from "@/modules/inc/service/Inc";
import CColumnHeader          from "@/modules/core/components/utils/CColumnHeader.vue";
import CIncMaintenanceIndex   from "@/modules/inc/maintenance/CIncMaintenanceIndex.vue";
import CDmsViewer             from "@/modules/dms/viewer/CDmsViewer.vue";
import FReadOnlyField         from "@/modules/core/components/utils/FReadOnlyField.vue";
import CDmsMenuDetails        from "@/modules/dms/menu/components/CDmsMenuDetails.vue";

export default {
    name: "CIncMaintenanceList",

    components: {
        CDmsMenuDetails,
        FReadOnlyField,
        CDmsViewer,
        CIncMaintenanceIndex,
        CColumnHeader
    },

    props: {
        site: {

        },

        readonly: {
            required: true,
            type    : Boolean
        },
    },

    data: () => ({
        maintenances: null,
        selected    : null,
        documentList: null,
        document    : null,
        refresh     : 0
    }),

    watch: {
        site: function () {
            this.load();
        }
    },

    mounted() {
        this.load();
    },

    computed: {
        documentName () {
            if (!this.document) {
                return null;
            }

            return this.document.name.replace(/\s+/g, '');
        }
    },

    methods: {
        load () {
            if (!this.site) {
                return;
            }

            Inc.maintenance.list(this.site.id) .then(data => {
                this.maintenances = data;
            })
        },

        onSelected (maintenance) {
            this.selected = maintenance;
            if (!maintenance) {
                this.document = null;
                this.documentList = null;
            } else {
                this.documentList = maintenance.documents;
                this.document = maintenance.documents[0];
            }
        },

        onDocument (document) {
            this.document = document;
        },

        format (value) {
            return Core.format.date.display(value);
        },

        html (text) {
            if (!text) {
                return "";
            }

            return text.replaceAll("\n", "<br>");
        },
    }
}
</script>

<style scoped>

.mnt-description {
    padding: 12px;
    min-height: 260px;
    max-height: 260px;
    overflow-y: auto;
}

.readonly-label {
    font-size: 11px;
}

</style>